import { TextField } from '@mui/material';

import { EmailFormProps } from './types';
import { REGEX } from '../../constant';

const EmailForm = (props: EmailFormProps) => {
  const { email, setEmail, isEmailValid, setIsEmailValid, ...options } = props;

  const handleEmailChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    if (newEmail === '') {
      setIsEmailValid(true);
      return;
    }

    setIsEmailValid(RegExp(REGEX.EMAIL).exec(newEmail) !== null);
  };

  return (
    <TextField
      error={!isEmailValid}
      helperText={
        !isEmailValid ? '正しいメールアドレスの形式で入力してください' : ''
      }
      label='メールアドレス'
      variant='outlined'
      fullWidth
      type='email'
      value={email}
      onChange={handleEmailChange}
      {...options}
    />
  );
};

export default EmailForm;
